module.exports = __webpack_public_path__ + "static/img/Prism-Selected.cbad4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Prism-Selected.png
// module id = 1578
// module chunks = 0